import { SAVE_STATE_TO_STORAGE } from './actionTypes';

const saveStateToStorage = () => ({
    type: SAVE_STATE_TO_STORAGE,
});

export default saveStateToStorage;
